"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var constants_1 = require("../../../../../constants");
var utils_1 = require("../../../../../pages/utils/utils");
var DruhyOsobOption_1 = require("./DruhyOsobOption");
var CasteZadavateleOption = function (_a) {
    var className = _a.className, zadavatel = _a.zadavatel, onRemove = _a.onRemove;
    var druhOsoby = zadavatel.druhOsoby, ico = zadavatel.ico, adresa = zadavatel.adresa, datovaSchranka = zadavatel.datovaSchranka;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(DruhyOsobOption_1.DivWithRightPadding, null,
            react_1.default.createElement("strong", null, zadavatel.nazev || utils_1.getJmenoPrijmeni(zadavatel.jmeno, zadavatel.prijmeni, zadavatel.titulPred, zadavatel.titulZa)),
            onRemove && react_1.default.createElement(DruhyOsobOption_1.StyledCloseButton, { onClick: onRemove })),
        ico && react_1.default.createElement(DruhyOsobOption_1.StyledText, null,
            "I\u010CO: ",
            ico || ''),
        datovaSchranka && react_1.default.createElement(DruhyOsobOption_1.StyledText, { style: { marginLeft: ico ? 20 : 0 } },
            "Datov\u00E1 schr\u00E1nka: ",
            datovaSchranka || ''),
        adresa && (react_1.default.createElement("div", null,
            react_1.default.createElement(DruhyOsobOption_1.StyledText, null,
                "Adresa ",
                druhOsoby !== constants_1.PosudkyTypOsoby.FyzickaOsoba ? 'sídla' : 'bydliště',
                ": ",
                adresa)))));
};
CasteZadavateleOption.defaultProps = {
    className: undefined,
    onRemove: undefined,
};
exports.default = styled_components_1.default(CasteZadavateleOption)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
